module.exports = __webpack_public_path__ + "img/signature-error.e677c051.png";